import { action, computed, observable } from 'mobx';
import { PRODUCTS, ProductStyle } from '@/store/Products';
import { Store } from '@/store/mainStore';

export const packs = ['Left Only', 'Right Only', 'Pair'] as const;
export type Packs = typeof packs[number];

export default class ProductStore {
	@observable currentStyle: ProductStyle = PRODUCTS[0];
	@observable pack: Packs = packs[2];
	store: Store;

	@observable currentSavedRXTitle: string = '';
	public assignedPackFromPresc = false;

	constructor(s: Store) {
		this.store = s;
	}

	@action setCurrentStyle(name: string) {
		const product = PRODUCTS.find((i) => i.title === name);
		// fallback on saved rx
		if (!product) {
			this.currentSavedRXTitle = name;
			return;
		}
		this.currentStyle = { ...product };
	}

	@action getAFOStyles() {
		return PRODUCTS.filter((i) => i.title.includes('AFO'));
	}

	@action getOrthoticStyles() {
		return PRODUCTS.filter((i) => !i.title.includes('AFO'));
	}

	@computed get getImage() {
		return this.currentStyle.src;
	}

	public assignProductPackFromPresc(productPack: Packs) {
		this.pack = productPack;
		this.assignedPackFromPresc = true;
	}

	public assignProductPackFromScans(leftScanExist: boolean, rightScanExist: boolean) {
		if (!leftScanExist && !rightScanExist) {
			return;
		}

		if (this.assignedPackFromPresc) {
			return;
		}

		this.pack = leftScanExist && rightScanExist ? packs[2] : rightScanExist ? packs[1] : packs[0];
	}

	@computed get orderType() {
		switch (this.store.product.pack) {
			case packs[0]:
				return 'Left orthotic';
			case packs[1]:
				return 'Right orthotic';
			case packs[2]:
				return 'Pair of orthotics';
		}
	}
}
